/* eslint-disable camelcase */
/* global dataLayer */
/*=========================================
=            All pages             =
=========================================*/

// If the store is the US store use the single Ometria list set up for signups
var isUkStoreMain =
  window.location.href.indexOf('us.babymori.com') === -1 &&
  window.location.href.indexOf('babymoriusa') === -1;

window.dataLayer = window.dataLayer || [];

/* Smooth scroll  ----------------*/
$(document).on('click', 'a[href*="#"]:not([href="#"])', function() {
  if (
    location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') ||
    location.hostname === this.hostname
  ) {
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
    if (target.length) {
      $('html,body').animate(
        {
          scrollTop: target.offset().top - 90,
        },
        1000
      );

      return false;
    }
  }
});

$(window).on('load', function() {

  offsetAnchors();

  // Remove all placeholder loaders
  setTimeout(function() {
    $('.placeholder-loader').removeClass('placeholder-loader');
  }, 3000); // TODO: Speed- change back to 300

  setContinueShoppingHref();
  loadDeferredImages();


  var meta_page_type = $("meta[name='page_type']").attr("content");

  var meta_collection_name = "";

  if($("meta[name='collection_name']").length != 0) {
    meta_collection_name = $("meta[name='collection_name']").attr("content");
  }

  if (dataLayer) {
    dataLayer.push({
      gtm_customer_currency: readCookie('cart_currency'),
      sitewide_customer_currency: readCookie('cart_currency'),
      page_type: meta_page_type,
      collection_name: meta_collection_name
    });
  }

  if ($("meta[name='bundle_collection_links']").attr('content') != undefined) {
  var build_a_bundle_collections = $("meta[name='bundle_collection_links']").attr('content').split(",");
  } else {
  var build_a_bundle_collections = [];
  }
  // console.log("build_a_bundle_collections");
  // console.log(build_a_bundle_collections);

  /* Runs on product added to cart  ----------------*/
  $('body').on('afterAddItem.ajaxCart afterChangeItem.ajaxCart', function(
    event,
    product
  ) {

    jQuery.getJSON('/cart.js', function(cart) {
      //updateTotalPrice(cart);

      // console.log("MAIN scritps ", cart);

      // Trigger Google Tag Manager Event:
      if (typeof product !== 'undefined') {
        console.log(product);
        dataLayer.push({
          event: 'afterAddItem.ajaxCart',
          gtm_product_name: product.title,
          gtm_product_price: (product.price / 100).toFixed(2),
          gtm_product_variant: product.variant_title,
          gtm_product_id: product.id,
          gtm_product_variant_id: product.variant_id,
          gtm_product_type: product.product_type,
          gtm_cart_total: (cart.items_subtotal_price / 100).toFixed(2)
        });
      }

     
      var hiddenProductsCounter = 0;
      for (var i = 0; i < cart.items.length; i++) {
        if (
          cart.items[i].handle === 'gift-note' ||
          cart.items[i].handle === 'gift-wrap-all' ||
          cart.items[i].handle === 'gift-wrap' ||
          cart.items[i].handle === 'gift-wrap-small' ||
          cart.items[i].handle === 'gift-wrap-extra-large' ||
          cart.items[i].handle === 'gift-wrap-large' ||
          cart.items[i].handle === 'gift-wrap-large-free' ||
          cart.items[i].handle === 'gift-wrap-medium' ||
          cart.items[i].handle === 'gift-box-small' ||
          cart.items[i].handle === 'gift-box-extra-large' ||
          cart.items[i].handle === 'gift-box-large' ||
          cart.items[i].handle === 'gift-box-medium' ||
          cart.items[i].handle === 'personalisation'
        ) {
          hiddenProductsCounter =
            hiddenProductsCounter + cart.items[i].quantity;
        }
      }

      $('.cart_amount_label').show(); // if hidden

      var visibleProductsAmount = cart.item_count - hiddenProductsCounter;

      $('.cart_amount_label').html(
        '<span>' + visibleProductsAmount + '</span>'
      );

      if (visibleProductsAmount === 0) {
        $('.cart_amount_label').hide();
      }

      checkIfShowOrHideWrapAll(visibleProductsAmount);
    });

    //
      
      // handle the collection pages 
      if (window.location.href.search("/build-a-bundle") != -1) {
        var code_to_apply = "BUNDLE&SAVE";
        createCookie("discount_codes", code_to_apply, 14);
      }

      //handle product pages of the list collections included
      if(document.referrer.search("pages/build-a-bundle") != -1) { 
      // only when a person is comming from a build-a-bundle page 

        for (var i = 0; i < build_a_bundle_collections.length; i++) {
          if( window.location.href.search(build_a_bundle_collections[i]+"/") != -1 ) {
            var code_to_apply = "BUNDLE&SAVE";
            createCookie("discount_codes", code_to_apply, 14);
          }
        }
      }

    //

  });

  

  // -------------------------- Blanket offer remove Cart drawer quantity selectors
  // on cart drawer open
  // afterCartLoad.ajaxCart

  jQuery(document.body).on('afterCartLoad.ajaxCart', function() {
    $('.ajaxcart__product').each(function() {
      var _this = $(this);
      var currentPrice;

      currentPrice = $(this)
        .find('.text-right.price span')
        .html()
        .substr(1);

      if (currentPrice === '0.00') {
        _this.find('.ajaxcart__qty').remove();
      }
    });
  });
});

$(window).on('hashchange', function() {
  offsetAnchors();
});

function offsetAnchors() {
  if (document.location.hash != "") {
    var header_height = $("#section-header").height();

    var waitUntillScrolled = setInterval(function(){

      var current_scroll = $(window).scrollTop();

      if (current_scroll != 0) {
        $(window).scrollTop(current_scroll - header_height);
        clearInterval(waitUntillScrolled);
      }

    }, 100);

  }
}

function checkIfShowOrHideWrapAll(visibleProductsAmount) {
  if (visibleProductsAmount <= 1) {
    if ($('#gift_wrap_all').length > 0) {
      if ($('#gift_wrap_all')[0].checked === false) {
        $('.gift_wrap_checkbox_wrapper').slideUp();
      } else {
        window.alert(
          'Please note that you only have one product in the cart now. \nThe gift wrap for an entire order no longer applies and will now be removed.'
        );
        $('#gift_wrap_all').click();
      }
    }
  } else {
    $('.gift_wrap_checkbox_wrapper').slideDown();
  }
}

function setContinueShoppingHref() {
  if (
    $('.continue_shopping').length !== -1 ||
    $('#CartDrawer .continue').length !== -1
  ) {
    var previousURL = document.referrer;

    if (
      (previousURL.search('babymori') !== -1 ||
        previousURL.search('minimori') !== -1) &&
      previousURL !== '' &&
      previousURL.search('/checkouts/') === -1 &&
      previousURL.search('/blogs/') === -1 &&
      previousURL.search('pages/our-story') === -1 &&
      previousURL.search('pages/terms-conditions') === -1 &&
      previousURL.search('pages/privacy-policy') === -1 &&
      previousURL.search('pages/faqs') === -1 &&
      previousURL.search('/account/') === -1 &&
      previousURL.search('pages/contact') === -1 &&
      previousURL.search('pages/shipments') === -1 &&
      previousURL.search('pages/kindness-project') === -1 &&
      previousURL.search('/products/') === -1
    ) {
      // if visitor is NOT coming from the external site or directly loading the cart page or coming from the pages that dont contain products

      $('.continue_shopping').attr('href', previousURL);

      $('#CartDrawer .continue').attr('href', previousURL);
    } else if (previousURL.search('/products/') !== -1) {
      //if the previous page is a product page, link to a collection the product is from

      previousURL = previousURL.split('/products/')[0];
      $('.continue_shopping').attr('href', previousURL);
    } else {
      // HACK: NVN - Commented out in JS to allow for syntax highlighting. Liquid should still function normally
      // 
      //   
      // 
      $('.continue_shopping').attr('href', '/collections/best-sellers');

      $('#CartDrawer .continue').attr('href', '/collections/best-sellers');
    }
  }
  var link = $('.continue_shopping').attr('href');
}

$(document).on('click', '#CartDrawer .continue', function(e) {
  e.preventDefault();
  setContinueShoppingHref();
  var new_href = $(this).attr('href');
  window.location.href = new_href;
});

function createCookie(name, value, days) {
  var expires;

  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toGMTString();
  } else {
    expires = '';
  }
  document.cookie =
    encodeURIComponent(name) +
    '=' +
    encodeURIComponent(value) +
    expires +
    '; path=/';
}

function readCookie(name) {
  var nameEQ = encodeURIComponent(name) + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0)
      return decodeURIComponent(c.substring(nameEQ.length, c.length));
  }

  return null;
}

// eslint-disable-next-line no-unused-vars
function eraseCookie(name) {
  createCookie(name, '', -1);
}

// HACK: NVN - Commented out in JS to allow for syntax highlighting. Liquid should still function normally
// 

function loadDeferredImages() {
  for (var i = $('.defer_image').length - 1; i >= 0; i--) {
    var currentImage = $($('.defer_image')[i]);

    if ($('.defer_image')[i].hasAttribute('data-bg-image')) {
      var deferredStyle = currentImage.attr('data-bg-image');
      currentImage.attr('style', deferredStyle);
    } else if ($('.defer_image')[i].hasAttribute('data-img-src')) {
      var deferredSrc = currentImage.attr('data-img-src');
      currentImage.attr('src', deferredSrc);
    }
  }
}

// if (isUkStoreMain) {
//   $(document).on('click', '.sleepclub_info_popup .close', function() {
//     $('.sleepclub_info_popup').hide();
//   });

//   $(document).on('click', '.sleepclub_info_popup', function(e) {
//     var $target = $(e.target);
//     if (!$target.is('.content_wrapper') && !$target.is('.content_wrapper *')) {
//       $('.sleepclub_info_popup').hide();
//     }
//   });

//   $(document).on('click', '.grid__item .sleepclub-price.small', function() {
//     $('.sleepclub_info_popup').show();
//   });
// }

$('.shopify-currency-form select').on('change', function() {
  var new_currency = $('.shopify-currency-form select').val();

  createCookie('cart_currency', new_currency);

  $(this)
    .parents('form')
    .submit();
});

function getParameterByName(name, url) {
  if (!url) {
    url = window.location.href;
  }
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;

  if (!results[2]) return '';

  return decodeURIComponent(results[2]);
}

var section_link = getParameterByName('section');
var scroll_offset = 150;

$(document).on('ready shopify:section:load', function() {
  if (section_link !== null) {
    $(window).scrollTop($('#' + section_link).offset().top - scroll_offset);
  }
});

// ============================= START Sleepclub events tracking 

// by default populate the cookie
if (readCookie("sleep-club-interaction") == null) {
  createCookie("sleep-club-interaction", "other", 3650);
}


// visitor lands on the SC page directly or from somewhere unknown
if (window.location.href.search("pages/sleepclub") != -1) {
  
  if(document.referrer == "") {
    createCookie("sleep-club-interaction", "sc-landing-page", 3650);
    createCookie("sleep-club-interaction-url", window.location.pathname + window.location.search, 3650);
  } else if( document.referrer != "" && 
    readCookie("sleep-club-interaction") != "main-menu" &&
    readCookie("sleep-club-interaction") != "thumbnail-price") {
      createCookie("sleep-club-interaction", "sc-landing-page", 3650);
      createCookie("sleep-club-interaction-url", "Navigated from: "+document.referrer, 3650);
  }

}

// visitor lands on the sleepclub-membership-signup page directly or from somewhere unknown
if (window.location.href.search("products/sleepclub-membership-signup") != -1) {
  if(document.referrer == "") {
    createCookie("sleep-club-interaction", "sleepclub-membership-signup", 3650);
    createCookie("sleep-club-interaction-url", window.location.pathname + window.location.search, 3650);
  } else if( document.referrer != "" && 
    document.referrer.indexOf("pages/sleepclub") == -1 &&
    readCookie("sleep-club-interaction") != "main-menu" &&
    readCookie("sleep-club-interaction") != "thumbnail-price") {

    createCookie("sleep-club-interaction", "sleepclub-membership-signup", 3650);
    createCookie("sleep-club-interaction-url", "Navigated from: "+document.referrer, 3650);
  }
}

$(document).on('click', '.level-1-link.sleep-club, .mobile-nav__item.sleep-club', function() {
  createCookie("sleep-club-interaction", "main-menu", 3650);
  createCookie("sleep-club-interaction-url", window.location.pathname + window.location.search, 3650);
});

$(document).on('click', '.sc-popup .learn_more a', function() {
  createCookie("sleep-club-interaction", "thumbnail-price", 3650);
  createCookie("sleep-club-interaction-url", window.location.pathname + window.location.search, 3650);
});

$(document).on('click', '#AddToCart', function() {
  if ($("#monthlyRadioBtn").length != 0 && $("#monthlyRadioBtn")[0].checked == true) {
    createCookie("sleep-club-interaction", "product-page", 3650);
    createCookie("sleep-club-interaction-url", window.location.pathname + window.location.search, 3650);
  }
});
// cookies for when the [+join sleepclub] button is clicked on the cart page are added in snippets/sleepclub-add-to-cart.es6

// ============================= END Sleepclub events tracking 


// ============================= START Location detection 
var current_url_on_us = "https://us.babymori.com" + window.location.href.split("babymori.com")[1];
var redirect_to_us = "https://us.babymori.com/" + window.location.search;

var current_url_on_eu = "https://eu.babymori.com/" + window.location.href.split("babymori.com")[1];
var redirect_to_eu = "https://eu.babymori.com/" + window.location.search;

var eu_countries = ["BE", "EL", "LT", "PT", "BG", "ES", "LU", "RO", "CZ", "FR", "HU", "SI", "DK", "HR", "MT", "SK", "DE", "IT", "NL", "FI", "EE", "CY", "AT", "SE", "IE", "LV", "PL"];

document.addEventListener("userLocationDetected", function (event) {
  if(event.detail != undefined && event.detail != null && event.detail != "") {  
    showCurrencySwitchPromptIfNeeded(event.detail);
    showLocationPopupIfNeeded(event.detail.country_code);
  }
});

// ============================= END Location detection

function hideKlarnaIfNeeded(country) {
  country = country || '';
  // Hide Klarna for non-UK customers
  if(country.toLowerCase() != "gb") {
    $("klarna-placement, .klarna_cart_icon").remove();
  }
}

function showCurrencySwitchPromptIfNeeded(location_data) {
  if( readCookie('currency_prompt_shown_once_2') != "true" ) {
    var countries_and_currencies_data = $("#currency_prompt_data").html();
    if (countries_and_currencies_data.length > 4) {
      var countries_and_currencies = JSON.parse(countries_and_currencies_data);
    } else {
      var countries_and_currencies = [];
    }


    // isUkStoreMain

    var shop_currency = $("meta[name='shop-currency-code']").attr("content");
    var cart_currency = $("meta[name='cart-currency-code']").attr("content");
    var currency_wasnt_switched = (shop_currency == cart_currency);
    var currency_prompt_country_found = false;

    var country = location_data.ip.country || '';

    // only run if the detected country doesn't match the customer's location
    if (currency_wasnt_switched && (isUkStoreMain && country.toLowerCase() != "gb" ||
      isUkStoreMain == false && country.toLowerCase() != "us")
    ) {

      if(countries_and_currencies.length != 0) {
        
        // prioritise countries for displaying pop-up
        for (var i = countries_and_currencies.length - 1; i >= 0; i--) {
          
          if(countries_and_currencies[i].country != "none" && countries_and_currencies[i].country.toLowerCase() == country.toLowerCase() ) {
            var currency_symbol = countries_and_currencies[i].currency_code.split("-")[0];
            var currency_code = countries_and_currencies[i].currency_code.split("-")[1];
            currency_prompt_country_found = true;
            showCurrencyPrompt(currency_symbol, currency_code);
            break
          }
        }

        // if no countries matched -- use continent
        if (currency_prompt_country_found == false) {
          for (var i = countries_and_currencies.length - 1; i >= 0; i--) {
            var continent = location_data.ip.continent || '';
            if(countries_and_currencies[i].continent != "none" && countries_and_currencies[i].continent.toLowerCase() == continent.toLowerCase() ) {
              var currency_symbol = countries_and_currencies[i].currency_code.split("-")[0];
              var currency_code = countries_and_currencies[i].currency_code.split("-")[1];
              showCurrencyPrompt(currency_symbol, currency_code);
              break
            }
          }
        }



      }

    }



  }
}

var currency_url = false; 
if (window.location.href.indexOf("currency=") != -1) {
  currency_url = true;
}

// use document.referrer == "" for demonstration. Replace with cookies 
// window.onload = function() {
//   if (currency_url == false && document.referrer == "") {
//     showCurrencyPrompt("$", "CAD");
//   }
// }

$(document).on('click touchstart', '.dismiss_btn', function(e) {
  e.stopPropagation();
  hideCurrencyPrompt();
});

function showCurrencyPrompt(currency_symbol, currency_code) {
  // cookie should only last a session 
  createCookie('currency_prompt_shown_once_2', 'true');
  var $all_prompts = $(".currency_change_prompt, .currency_change_prompt-mobile");
  $all_prompts.find(".currency_code").html(currency_code);
  $all_prompts.find(".currency_symbol").html(currency_symbol);
  setTimeout(function(){
      $all_prompts.addClass("activated");
      setTimeout(function(){
        $all_prompts.addClass("shown");
      }, 100);
  }, 2000);

  dataLayer.push({
      'currency_of_currency_prompt': currency_code,
      event: 'currency_prompt_shown'
  });
}

function hideCurrencyPrompt() {
  var currency_code = $(".currency_change_prompt .currency_code").html();
  dataLayer.push({
      'currency_of_currency_prompt': currency_code,
      event: 'currency_prompt_dismissed'
  });

  $(".currency_change_prompt, .currency_change_prompt-mobile").removeClass("shown");
  setTimeout(function(){
    $(".currency_change_prompt, .currency_change_prompt-mobile").removeClass("activated");
  }, 1000);
}

$(document).on('click touchstart', '.currency_change_prompt, .currency_change_prompt-mobile', function(e) {
  e.stopPropagation();
  var suggested_currency = $(".currency_change_prompt .currency_code").text();
  var current_url = window.location.href;
  
  var currency_code = $(".currency_change_prompt .currency_code").html();
  if (dataLayer) {
    dataLayer.push({
        'currency_of_currency_prompt': currency_code,
        event: 'currency_prompt_clicked'
    });
  }

  if (current_url.indexOf("?") != -1 ) {
    window.location.href = current_url + "&currency=" + suggested_currency;
  } else {
    window.location.href = current_url + "?currency=" + suggested_currency; 
  }
});

// ============================= END Currency change prompt 
